export default __webpack_public_path__ + "static/media/img-visionEearthBg.0700fa13.png";